export const fieldClassName =
  "w-full rounded-md border border-[#E6E8EC] dark:border-[#0B2E57] bg-white dark:bg-[#0F3B7C] px-3 py-2 text-sm text-dark-grey dark:text-white placeholder:text-dark-grey/60 dark:placeholder:text-white/60";
